import React from "react";
import { Trans, useTranslation } from "react-i18next";
import BottomSheet from "../ui/BottomSheet";
import Button from "../ui/Button";
import { formatEuros } from "../../utils/format";

const MILESTONES = [
  { key: "start", dot: "bg-qv-brand" },
  { key: "during", dot: "bg-qv-brand" },
  { key: "end", dot: "bg-qv-green" },
];

// Écran 1k : la préautorisation expliquée, sans quitter le paiement.
export default function HowItWorksSheet({ open, onClose }) {
  const { t, i18n } = useTranslation();

  return (
    <BottomSheet open={open} onClose={onClose} title={t("howItWorks.title")} showClose>
      <p className="mb-5 text-sm leading-5 text-qv-muted">{t("howItWorks.subtitle")}</p>

      <ol className="mb-5 flex flex-col">
        {MILESTONES.map(({ key, dot }, index) => (
          <li key={key} className="flex gap-3">
            <div className="flex flex-col items-center pt-1.5">
              <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${dot}`} />
              {index < MILESTONES.length - 1 && <span className="my-1 w-0.5 flex-1 bg-qv-brand-100" />}
            </div>
            <div className={index < MILESTONES.length - 1 ? "pb-3" : ""}>
              <p className="text-[15px] font-bold">{t(`howItWorks.${key}Title`)}</p>
              <p className="text-sm leading-5 text-qv-muted">
                <Trans i18nKey={`howItWorks.${key}Text`} components={[<b className="text-qv-ink" />]} />
              </p>
            </div>
          </li>
        ))}
      </ol>

      <div className="mb-5 rounded-2xl bg-qv-brand-50 p-4 text-sm">
        <p className="mb-2 text-xs font-semibold tracking-[.08em] uppercase text-qv-brand-900">
          {t("howItWorks.example")}
        </p>
        <div className="flex justify-between">
          <span>{t("howItWorks.exampleCharged")}</span>
          <b>{t("howItWorks.exampleDebited", { amount: formatEuros(5.88, i18n.language) })}</b>
        </div>
        <div className="mt-1 flex justify-between">
          <span>{t("howItWorks.exampleReleased")}</span>
          <b className="text-qv-green">{formatEuros(34.12, i18n.language)}</b>
        </div>
      </div>

      <Button onClick={onClose}>{t("howItWorks.gotIt")}</Button>
    </BottomSheet>
  );
}
